import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import arMessages from "./messages/ar.json";
import enMessages from "./messages/en.json";

export const defaultNS = "translation";
export const resources = {
  en: { translation: enMessages },
  ar: { translation: arMessages },
} as const;

void i18n.use(detector).init({
  debug: false,
  supportedLngs: ["en", "ar"],
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
  ns: ["translation"],
  defaultNS,
  resources,
});

const root = document.documentElement;
root.setAttribute("dir", i18n.language === "ar" ? "rtl" : "ltr");
root.setAttribute("lang", i18n.language);

export default i18n;
